import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Alert from "react-bootstrap/Alert";
import { Trans } from "react-i18next";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Button } from "react-bootstrap";
import axios from "axios";
import { environment } from "../../../environment.js";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { LinkContainer } from "react-router-bootstrap";

import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import NavbarNew from "../../Components/NavbarNew.js";
const { SearchBar } = Search;

const MySwal = withReactContent(Swal);

const ReturnShipment = () => {
  const [notification, setNotification] = useState([]);
  const [shipments, setShipments] = useState([]);

  const defaultSorted = [
    {
      dataField: "id",
      order: "desc",
    },
  ];

  useEffect(() => {
    axios
      .get(environment.dap_url + "shipmentApi/getAllShipment")
      .then((res) => {
        let actualData = res.data;

        console.log(res.data);
        const userData = JSON.parse(localStorage.getItem("user"));
        const okData = actualData.filter(
          (item) =>
            item.parentId == userData._id &&
            item.isShipmentReturn == true &&
            item.shipmentLogs.length >= 2
        );
        setShipments(okData.reverse());
      })
      .catch(function (error) {
        MySwal.fire({
          title: <p>{error.message}</p>,
          type: "error",
        });
      });
  }, []);

  const formatDate = (date) => {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  };
  const columns = [
    {
      dataField: "sl.no",
      text: "#",
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return rowIndex + 1;
      },
      sort: true,
    },
    {
      dataField: "shipmentUniqueId",
      text: "Shipment ID",
      sort: true,
    },
    {
      dataField: "consigneedetails[0].userFirstName",
      text: "Partner",
      sort: true,
    },
    {
      dataField: "consignordetails[0].userFirstName",
      text: "Consignor",
      sort: true,
    },
    {
      dataField: "consignmentState",
      text: "State",
      sort: true,
    },
    {
      dataField: "consignmentCountry",
      text: "Country",
      sort: true,
    },
    {
      dataField: "address",
      text: "Address",
      sort: true,
    },
    {
      dataField: "status",
      text: "Status",
      sort: true,

      formatter: (dataField) => {
        return (
          <div>
            {dataField == 0 ? (
              <button
                type="button"
                class="btn btn-primary btn-sm"
                style={{ backgroundColor: "#6867AC" }}
              >
                Initalized
              </button>
            ) : dataField == 1 ? (
              <button
                type="button"
                class="btn btn-primary btn-sm"
                style={{
                  backgroundColor: "#59a9eb",
                  borderColor: "#59a9eb",
                }}
              >
                Finalized
              </button>
            ) : dataField == 5 ? (
              <button
                type="button"
                class="btn btn-primary btn-sm"
                style={{
                  backgroundColor: "#E6B566",
                  borderColor: "rgb(230, 181, 102)",
                }}
              >
                In - Transit
              </button>
            ) : dataField == 3 ? (
              <button
                type="button"
                class="btn btn-primary btn-sm"
                style={{
                  backgroundColor: "#E6B566",
                  borderColor: "rgb(230, 181, 102)",
                }}
              >
                Approved
              </button>
            ) : dataField == 4 ? (
              <button
                type="button"
                class="btn btn-primary btn-sm"
                style={{
                  backgroundColor: "#E6B566",
                  borderColor: "rgb(230, 181, 102)",
                }}
              >
                Rejected
              </button>
            ) : dataField == 6 ? (
              <button
                type="button"
                class="btn btn-primary btn-sm"
                style={{
                  backgroundColor: "#E6B566",
                  borderColor: "rgb(230, 181, 102)",
                }}
              >
                shipment received
              </button>
            ) : dataField == 7 ? (
              <button
                type="button"
                class="btn btn-primary btn-sm"
                style={{
                  backgroundColor: "#E6B566",
                  borderColor: "rgb(230, 181, 102)",
                }}
              >
                All Boxes Received
              </button>
            ) : dataField == 8 ? (
              <button
                type="button"
                class="btn btn-primary btn-sm"
                style={{
                  backgroundColor: "#E6B566",
                  borderColor: "rgb(230, 181, 102)",
                }}
              >
                All device Installed
              </button>
            ) : (
              ""
            )}
            {/* {(() => {
              switch (dataField) {
                case 0:
                  return "Initialized";
                case 1:
                  return "Finalized";
                case 3:
                  return "Approved";
                case 4:
                  return "Rejected";
                case 5:
                  return "In Transit";
                case 6:
                  return "shipment received";
                case 7:
                  return "All boxes Received";
                case 8:
                  return "All device Installed";
                default:
                  return "";
              }
            })()} */}
          </div>
        );
      },
    },
    {
      dataField: "createdAt",
      text: "Date",
      sort: true,
      formatter: (dataField) => {
        return formatDate(dataField);
      },
    },
    {
      dataField: "docketNo",
      text: "Docket No.",
      sort: true,
    },

    {
      dataField: "_id",
      text: "Action",
      sort: false,
      formatter: (dataField) => {
        var disable = false;
        shipments.every((element) => {
          if (element._id == dataField && element.docketNo) {
            disable = true;
            return false;
          } else {
            disable = false;
            return true;
          }
        });
        return (
          <div>
            <LinkContainer
              to={"/returnShipment/" + dataField}
              style={{
                float: "center",
              }}
            >
              <Button variant="light" className="btn-sm">
                <i className="fa fa-eye"></i>
              </Button>
            </LinkContainer>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <div className="container-fluid">
        <NavbarNew />
        <h4 className="card-title">RETURN SHIPMENTS</h4>

        <ToolkitProvider
          keyField="id"
          bootstrap4
          data={shipments}
          columns={columns}
          search
        >
          {(props) => (
            <div>
              <div className="d-flex align-items-center">
                <p className="mb-2 mr-2">Search in table:</p>
                <SearchBar {...props.searchProps} />
              </div>

              <BootstrapTable
                defaultSorted={defaultSorted}
                pagination={paginationFactory()}
                {...props.baseProps}
                wrapperClasses="table-responsive"
              />
            </div>
          )}
        </ToolkitProvider>
      </div>
    </>
  );
};

export default ReturnShipment;
